module.exports = __webpack_public_path__ + "img/icon-404.500e7ab9.svg";